import EntityListContainer from './EntityListContainer'
import EntityDetail from './EntityDetail'
import { setRoles } from './AclDataProvider/actions'
import { Detail, Functions, Spaces, Users } from './DetailPanels'
import { Users as UsersIcon } from 'react-feather'

getUsers = (role) ->
  (await Weaver.User.list()).filter((user) ->
    user.id() in role.getUsers()
  )

addUser = (role, user) ->
  role.addUser(user)
  await role.save()
  user

removeUser = (role, user) ->
  role.removeUser(user)
  role.save()

getSpaces = (role) ->
  Promise.filter(await Weaver.Project.list(), (space) ->
    if (await space.getACL()).getRoleReadAccess(role)
      getPermissions(role, space)
    else
      false
  )

getPermissions = (role, space) ->
  space.acl = await space.getACL()
  space.hasReadAccess = space.acl.getRoleReadAccess(role)
  space.hasWriteAccess = space.acl.getRoleWriteAccess(role)
  space.hasReadAccess or space.hasWriteAccess

addSpace = (role, space) ->
  space.acl = await space.getACL()
  space.acl.setRoleReadAccess(role, true)
  await space.acl.save()
  await getPermissions(role, space)
  space

setWriteAccess = (role, space, canWrite) ->
  space.acl.setRoleWriteAccess(role, canWrite)
  space.acl.save()

removeSpace = (role, space) ->
  space.acl.setRoleReadAccess(role, false)
  space.acl.setRoleWriteAccess(role, false)
  space.acl.save()

getFunctionPermissions = (role, acl) ->
  acl.hasRoleReadAccess = acl.getRoleReadAccess(role)
  acl.hasRoleWriteAccess = acl.getRoleWriteAccess(role)

  acl.hasReadAccess = acl.hasRoleReadAccess
  acl.hasWriteAccess = acl.hasRoleWriteAccess

  acl

getFunctions = (role) ->
  Promise.filter(await Weaver.ACL.list(), (acl) ->
    await getFunctionPermissions(role, acl)
    acl.hasRoleReadAccess and acl._functionACL
  )

addFunction = (role, acl) ->
  acl.setRoleReadAccess(role, true)
  await acl.save()
  getFunctionPermissions(role, acl)

setFunctionWriteAccess = (role, acl, canWrite) ->
  acl.setRoleWriteAccess(role, canWrite)
  acl.hasWriteAccess = canWrite
  await acl.save()

removeFunction = (role, acl) ->
  acl.setRoleReadAccess(role, false)
  acl.setRoleWriteAccess(role, false)
  acl.save()

export DetailView = EntityDetail({
  getItem: (id) ->
    if id is 'new'
      role = new Weaver.Role('new-role')
      role.isCreating = true
      role
    else
      (await Weaver.Role.list()).find((role) ->
        role.id() is id
      )
  icon: 'users'
  title: (role) -> role.name()
  tabs: [{
    title: 'Group Detail'
    Component: Detail({
      displayName: (item) -> item.name()
      fields: () -> [{ field: '_name', label: 'Name' }]
      onDelete: ({ history, item })->
        await item.destroy()
        history.push('/acl/roles')
    })
  }, {
    title: 'Members'
    Component: Users({ getUsers, addUser, removeUser })
  }, {
    title: 'Space Access'
    Component: Spaces({ getSpaces, addSpace, setWriteAccess, removeSpace })
  }, {
    title: 'Granted Permissions'
    Component: Functions({ getFunctions, addFunction, setWriteAccess: setFunctionWriteAccess, removeFunction })
  }]
})

export ListView = EntityListContainer({
  title: 'User groups'
  singular: 'user group'
  singularRoute: 'groups'
  Icon: UsersIcon
  init: ->
    roles = _.filter(await Weaver.Role.list(), ['_isDomain', false])
    setRoles(roles)
  reducerKey: 'groups'
  filterer: (str) -> (item) -> item.name().toLowerCase().indexOf(str.toLowerCase()) isnt -1
  itemProps: {
    title: (item) -> item.name()
    description: (item) -> _.values(item._usersMap).length + ' active users'
    key: (item) -> item.id()
  }
})
